import {
  setupInputFocusModality,
} from "../../utils/keyboardAccessibility"

setupInputFocusModality()

// Breadcrumb accessibility: announce and focus only once per page load
function setupBreadcrumbAccessibility() {
  var breadcrumbLiveRegion = document.getElementById('breadcrumb-live-region');
  if (breadcrumbLiveRegion) {
    breadcrumbLiveRegion.textContent = '';
    setTimeout(function() {
      breadcrumbLiveRegion.style.display = 'none';
      void breadcrumbLiveRegion.offsetHeight;
      breadcrumbLiveRegion.style.display = '';
      breadcrumbLiveRegion.textContent = 'You are in the breadcrumb navigation.';
    }, 500);
  }

  var breadcrumbNav = document.getElementById('breadcrumb-nav');
  var main = document.querySelector('main');
  if (main && breadcrumbNav) {
    var hasAnnouncedBreadcrumb = false;
    var announceBreadcrumbOnce = function() {
      if (!hasAnnouncedBreadcrumb) {
        hasAnnouncedBreadcrumb = true;
        breadcrumbNav.focus();
        if (breadcrumbLiveRegion) {
          breadcrumbLiveRegion.textContent = '';
          setTimeout(function() {
            breadcrumbLiveRegion.textContent = 'You are in the breadcrumb navigation.';
          }, 100);
        }
        main.removeEventListener('focus', announceBreadcrumbOnce);
      }
    };
    main.addEventListener('focus', announceBreadcrumbOnce);
  }
}

// No custom JS handlers for submit button accessibility. Rely on browser native behavior for <button type="submit">.
//Ensures correct tab order for quiz answer radios and strike-through buttons.
// For any new feature with a similar format (radio buttons and strike-through buttons), simply set the appropriate tabindex attributes in the relevant template or markup file.
const ACCESSIBILITY_EVENTS = ['DOMContentLoaded', 'turbo:load', 'turbo:frame-load', 'card:content:loaded'];

function setupQuizTabOrder() {
  const container = document.querySelector('.text-highlight');
  if (!container) return;
  const radios = Array.from(container.querySelectorAll('.player-form-check-input[type="radio"]'));
  const strikeButtons = Array.from(container.querySelectorAll('button[data-action*="toggleCheckbox"]'));
  const tabbables = [];
  for (let i = 0; i < radios.length; i++) {
    tabbables.push(radios[i]);
    if (strikeButtons[i]) tabbables.push(strikeButtons[i]);
  }
  tabbables.forEach((el, idx) => {
    el.onkeydown = function(e) {
      if (e.key === 'Tab') {
        if (!e.shiftKey) {
          if (idx < tabbables.length - 1) {
            e.preventDefault();
            tabbables[idx + 1].focus();
          }
        } else {
          if (idx > 0) {
            e.preventDefault();
            tabbables[idx - 1].focus();
          }
        }
      }
    };
  });
}

function setupSpacebarActivation() {
  document.querySelectorAll('[data-spacebar-activates="true"]').forEach(function(el) {
    if (el.dataset.spacebarActivationBound === 'true') return;
    el.dataset.spacebarActivationBound = 'true';
    el.addEventListener('keydown', function(e) {
      if (e.key === ' ' || e.key === 'Spacebar' || e.code === 'Space') {
        e.preventDefault();
        el.click();
      }
    });
  });
}

function handler() {
  document.querySelectorAll('.info-bubble').forEach(function(bubble) {
    if (bubble.dataset.keyboardTooltipBound === 'true') return;
    bubble.dataset.keyboardTooltipBound = 'true';
    bubble.addEventListener('focus', function() {
      const tooltip = bubble.querySelector('.tooltip-box');
      if (tooltip) {
        tooltip.classList.add('visible');
      }
    });
    bubble.addEventListener('keydown', function(e) {
      const tooltip = bubble.querySelector('.tooltip-box');
      if ((e.key === 'Enter' || e.key === ' ') && tooltip) {
        e.preventDefault();
        tooltip.classList.toggle('visible');
      } else if (e.key === 'Escape' && tooltip && tooltip.classList.contains('visible')) {
        e.stopPropagation();
        tooltip.classList.remove('visible');
      }
    });
    bubble.addEventListener('blur', function() {
      const tooltip = bubble.querySelector('.tooltip-box');
      if (tooltip) {
        tooltip.classList.remove('visible');
      }
    });
  });
}

ACCESSIBILITY_EVENTS.forEach(eventName => {
  document.addEventListener(eventName, setupQuizTabOrder);
});

ACCESSIBILITY_EVENTS.forEach(eventName => {
  document.addEventListener(eventName, setupSpacebarActivation);
});

ACCESSIBILITY_EVENTS.forEach(eventName => {
  document.addEventListener(eventName, handler);
});

ACCESSIBILITY_EVENTS.forEach(eventName => {
  document.addEventListener(eventName, setupBreadcrumbAccessibility);
});
